/**
 * Application Insights keys that Azure refuses ("Invalid instrumentation key",
 * HTTP 400): checked 2026-10-22 against
 * https://canadacentral-1.in.applicationinsights.azure.com/v2/track
 * (QA batch 16, NAV-027). 8c1ec4c5… = devConfig "localWebToLhrApiService";
 * b6adef35… ("azProcDev") still answered 200.
 */
export const RETIRED_INSTRUMENTATION_KEYS = [
  "8c1ec4c5-d8d4-4176-9f28-e60ac5903570",
];

/** Telemetry is sent only with a connection string whose key Azure accepts. */
export const isUsableConnectionString = (connectionString?: string | null) => {
  const text = (connectionString || "").toLowerCase();
  if (!/instrumentationkey=[0-9a-f-]{36}/.test(text)) return false;
  return !RETIRED_INSTRUMENTATION_KEYS.some((key) => text.includes(key));
};
